import React from 'react';
import { Link } from 'react-router-dom';
import "./Navbar.css";
import { useState } from 'react';

const Navbar = () => {
     const [isMobile, setIsMobile] = useState(false);
    return (
        <nav className="navbar">

            <a href="/" className="logo"><img alt="" src={process.env.PUBLIC_URL + '/icon.ico'} /></a>

            <ul className={ isMobile?"nav-links-mobile":"nav-links" }
            onClick={()=>setIsMobile(false)}
            >
                <Link to="/" className="home link"><li data-hover="Home">Home</li></Link>
                <Link to="/about" className="about link"><li data-hover="About">About</li></Link>
                <Link to="/contact" className="contact link"><li data-hover="Contact">Contact</li></Link>
                <Link to="/project" className="project link"><li data-hover="Project">Project</li></Link>
                {/* <a href={"http://devanshujotwani.com/"} className="link" target="_blank" rel='noreferrer'  ><li data-hover="Porfolio">Portfolio</li></a> */}


            </ul>
            <button className="mobile-menu-icon"
            onClick={()=>setIsMobile(!isMobile)}>
                {isMobile ? <i className="fa fa-times"></i>:<i className="fa fa-bars"></i>}
            </button>
        </nav>
    )
}

export default Navbar
